/* Read more deshabilitado (2026-07-31, pedido del cliente): la descripción
   ya no se recorta en móvil (ver bloque comentado en
   section-hero-collections.css), así que el botón no hace falta. Quitar el
   return para reactivar la funcionalidad. */
const READ_MORE_DISABLED = true;

document.addEventListener('DOMContentLoaded', function () {
    if (READ_MORE_DISABLED) return;

    const descriptions = document.querySelectorAll('.section-hero-collections .description-product');

    function checkOverflow() {
        descriptions.forEach(description => {
            const button = description.nextElementSibling;
            if (!button || !button.classList.contains('button-read-more')) return;

            // Con la descripción expandida no se re-evalúa: el botón debe
            // seguir visible para poder colapsarla de nuevo.
            if (!description.classList.contains('active')) {
                // scrollHeight incluye el contenido recortado por max-height
                // y el margin del <p> interno; clientHeight es la caja
                // colapsada. Comparar el scrollHeight del <p> contra la caja
                // (versión anterior) ignoraba el margin-top del párrafo y
                // dejaba descripciones de ~5 líneas recortadas pero sin
                // botón (p. ej. Sardines en iPhone).
                button.classList.toggle('active', description.scrollHeight > description.clientHeight + 1);
            }

            // Sólo se añade el listener una vez.
            if (!button.dataset.listenerAttached) {
                button.addEventListener('click', () => {
                    description.classList.toggle('active');
                    button.textContent = description.classList.contains('active') ? 'Read less' : 'Read more';
                });
                button.dataset.listenerAttached = 'true';
            }
        });
    }

    checkOverflow();

    // Safari: la fuente (Gilroy) suele cargar después de DOMContentLoaded y
    // re-envuelve el texto sin cambiar el alto de la caja recortada, así que
    // ni resize ni ResizeObserver se disparan — re-evaluar cuando terminan
    // de cargar las fuentes y la página.
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkOverflow);
    }
    window.addEventListener('load', checkOverflow);

    window.addEventListener('resize', checkOverflow);

    // Cambios de tamaño del contenedor (p. ej. al colapsar de nuevo o al
    // rotar el dispositivo) re-evalúan el estado del botón.
    const resizeObserver = new ResizeObserver(checkOverflow);
    descriptions.forEach(desc => resizeObserver.observe(desc));
});
